import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _compact from 'lodash/compact';
import SVG from 'react-inlinesvg';
import micIcon from '@lifesize/ux-assets/vectors/svgIcons/mic.svg';
import micOffIcon from '@lifesize/ux-assets/vectors/svgIcons/mic-off.svg';
import videoIcon from '@lifesize/ux-assets/vectors/svgIcons/video.svg';
import videoOffIcon from '@lifesize/ux-assets/vectors/svgIcons/video-off.svg';
import Tooltip from 'components/Tooltip/Tooltip';
import PreviewVideo from 'components/PreviewVideo/PreviewVideo';
import SourceDisplay from 'containers/AvSourceDisplay/AvSourceDisplayContainer';
import classes from './CallPreview.module.scss';

class CallPreview extends React.PureComponent {
  renderVideoButton = () => {
    const videoClassNames = _compact([
      classes.preCallButton,
      this.props.defaultVideoSetting ? '' : classes.muted
    ]).join(' ');

    return (
      <button
        className={videoClassNames}
        onClick={() => this.props.onVideoMuteClick()}
      >
        {this.props.defaultVideoSetting ? <SVG src={videoIcon} data-testid="videoIconOn" /> : <SVG src={videoOffIcon} data-testid="videoOffIcon"/>}
        <Tooltip
          location="top"
          style={{ bottom: '100%', marginBottom: 15 }} label={
            this.props.defaultVideoSetting ?
              <FormattedMessage
                id="components.callPreview.controls.videoMute.tooltip.off"
                defaultMessage="Turn camera off"
              /> :
              <FormattedMessage
                id="components.callPreview.controls.videoMute.tooltip.on"
                defaultMessage="Turn camera on"
              />
          }
        />
      </button>);
  };

  renderAudioButton = () => {
    const audioClassNames = _compact([
      classes.preCallButton,
      this.props.defaultAudioSetting ? '' : classes.muted
    ]).join(' ');

    return (
      <button
        className={audioClassNames}
        onClick={() => this.props.onAudioMuteClick()}
      >
        {this.props.defaultAudioSetting ? <SVG src={micIcon} data-testid="micIcon" /> : <SVG src={micOffIcon} data-testid="micOffIcon" />}
        <Tooltip
          location="top"
          style={{ bottom: '100%', marginBottom: 15 }} label={
            this.props.defaultAudioSetting ?
              <FormattedMessage
                id="components.callPreview.controls.audioMute.tooltip.off"
                defaultMessage="Mute microphone"
              /> :
              <FormattedMessage
                id="components.callPreview.controls.audioMute.tooltip.on"
                defaultMessage="Unmute Microphone"
              />
          }
        />
      </button>);
  };

  render() {
    return (<div className={classes.container}>
      {this.props.inActiveCall ?
        <PreviewVideo {...this.props} />
        :
        <SourceDisplay videoOnly {...this.props} />
      }
      <div className={classes.buttonBar}>
        {this.renderVideoButton()}
        {this.renderAudioButton()}
      </div>
    </div>);
  }
}


CallPreview.propTypes = {
  defaultVideoSetting: PT.bool,
  defaultAudioSetting: PT.bool,
  inActiveCall: PT.bool,
  onVideoMuteClick: PT.func,
  onAudioMuteClick: PT.func
};

export default CallPreview;
